<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <b-tabs>
            <b-tab :title="$t('certificates.assign_certificate')" active>
              <add-assign-certificate/>
            </b-tab>
            <b-tab @click="newItem= {}" :title="$t('certificates.assigned_certificates')">
               
            </b-tab>
          </b-tabs>
        </div>
        <!-- end of card body -->
      </div>
      <!-- end of card -->
    </div>
    <!-- end of col -->
  </div>
</template>

<script>
import AddAssignCertificate  from './components/AddAssignCertificate.vue'
 
export default {
    components:{
        AddAssignCertificate
    }
 }
</script>

<style>

</style>